import controlsDetailsSlideOutOpenerController from "../../../controls/assets/javascript/controls-details-slide-out-opener-controller";

export default class extends controlsDetailsSlideOutOpenerController {}



// WEBPACK FOOTER //
// ./app/components/time_entries/assets/javascript/time-entries-form-link-controller.js